// extracted by mini-css-extract-plugin
export default {"slider":"agent-plan-price_slider__2AUIX","level":"agent-plan-price_level__VfzM1","loading":"agent-plan-price_loading__D35Sa"};